import { render, staticRenderFns } from "./CreateTagModal.vue?vue&type=template&id=35198372&"
import script from "./CreateTagModal.vue?vue&type=script&lang=js&"
export * from "./CreateTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports